

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister 
// CUSTOMERREGISTER
const RESETPASSWORDFORCUSTOMER= createAsyncThunk(
  "resetPasswordForCustomer/resetPasswordForCustomer",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const resetPasswordForCustomerSlice = createSlice({
  name: "resetPasswordForCustomerSlice",
  initialState: {
    resetPasswordForCustomer: {
      ...defaultState.List,
      loading: false, 
      error: false, 
      data: [], // Ensure data starts as an empty array
      message: '', // Ensure message starts as an empty string
    },
  },
  reducers: {
    setInitialStateOfresetPasswordForCustomer: (state) => {
      state.resetPasswordForCustomer.loading = false;
      state.resetPasswordForCustomer.error = false;
      state.resetPasswordForCustomer.data = []; // Clear data
      state.resetPasswordForCustomer.message = ''; // Clear message
    },
  
  },
  extraReducers: (builder) => {
    builder.addCase(RESETPASSWORDFORCUSTOMER.fulfilled, (state, action) => {
      state.resetPasswordForCustomer = {
        ...state.resetPasswordForCustomer,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(RESETPASSWORDFORCUSTOMER.pending, (state, action) => {
      state.resetPasswordForCustomer = {
        ...state.resetPasswordForCustomer,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(RESETPASSWORDFORCUSTOMER.rejected, (state, action) => {
      state.resetPasswordForCustomer = {
        ...state.resetPasswordForCustomer,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const resetPasswordForCustomerAction = {
    RESETPASSWORDFORCUSTOMER,
};

export { resetPasswordForCustomerAction };
export default resetPasswordForCustomerSlice.reducer;
export const {setInitialStateOfresetPasswordForCustomer} = resetPasswordForCustomerSlice.actions
